import 'css/app.scss';
import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as productActions from './actions';
import { track } from 'shared/models/analytic';
import { trackInfo } from 'shared/models/product';
import Text from '../ui/text';
import View from '../ui/view';
import Recommendation from '../recommendation';
import LeadCaptureModal from '../leadCaptureModal';
import HeadTags from './head';
import Breadcrumbs from './breadcrumbs';
import ProductSummary from './summary';
import ProductRatings from './ratings';
import Spinner from 'react-spinkit';
import ProductImage from 'shared/components/ui/productImage';
import { capitalize } from 'shared/utils';
import { isEqual as sameAddress } from 'shared/models/address';

class Product extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ratingValue: null,
      ratingCount: null
    };
  }

  loadProduct(sku) {
    this.props.getPrices(sku);
    this.props.getRelatedProducts(sku);
    this.props.fetchProduct(sku).then(product => {
      this._trackView(product);
      this.props.getParentCategories();
    });
  }

  _skuFromRoute(props) {
    return props.match.params.sku;
  }

  _trackView(product) {
    track('Product Viewed', trackInfo(product));
  }

  componentDidMount() {
    /* navigate to product page, then non-product page,
     * then different product page */
    const oldSku = this.props.product.sku_id;
    const newSku = this._skuFromRoute(this.props);
    if (oldSku !== newSku) this.loadProduct(newSku);
    else this._trackView(this.props.product);
  }

  componentWillReceiveProps(nextProps) {
    if (!sameAddress(this.props.address, nextProps.address)) {
      this.loadProduct(this._skuFromRoute(nextProps));
    }

    /* navigate from product page to different product page */
    const oldSku = this._skuFromRoute(this.props);
    const newSku = this._skuFromRoute(nextProps);
    if (oldSku !== newSku) this.loadProduct(newSku);
  }

  handleRatingsLoaded(ratings) {
    this.props.loadRatings(ratings);
  }

  render() {
    const {
      product,
      productLoading,
      previewingProduct,
      moreByBrand,
      moreByBrandLoading,
      similarProducts,
      boughtWith,
      boughtWithLoading,
      parentCategories
    } = this.props;

    const category = product.category || {};
    const loading = productLoading && !previewingProduct;
    const brandName = capitalize(product.company || product.brand);

    return (
      <div className="product-page banner-padding">
        {!productLoading && (
          <HeadTags
            product={product}
            parentCategories={parentCategories}
            ratingValue={this.state.ratingValue}
            ratingCount={this.state.ratingCount}
            ratings={this.props.ratings}
          />
        )}

        <div className="product-page__container">
          <section className="product-page__card">
            <div className="row">
              <div className="col-xs-12 col-sm-5">
                <div className="product-page__img-container">
                  <ProductImage
                    large
                    product={product}
                    loading={loading}
                    className="product-page__img"
                    alt={!loading && product.title}
                  />

                  {!!moreByBrand.length && (
                    <div className="visible-sm-block">
                      {product.brandUrl && (
                        <Link to={product.brandUrl}>
                          <Text title tag="h3" weight="med" size="xs">
                            {`More By ${brandName}`}
                          </Text>
                        </Link>
                      )}
                      <Recommendation
                        thumbnail
                        link
                        list={moreByBrand}
                        loading={!previewingProduct && moreByBrandLoading}
                        slidesToShow={4}
                        slidesToScroll={4}
                      />
                    </div>
                  )}

                  {!moreByBrand.length &&
                    !!boughtWith.length && (
                      <div className="visible-sm-block">
                        <Text title tag="h3" weight="med" size="xs">
                          Often Bought With
                        </Text>
                        <Recommendation
                          thumbnail
                          link
                          list={boughtWith}
                          loading={!previewingProduct && boughtWithLoading}
                          slidesToShow={4}
                          slidesToScroll={4}
                        />
                      </div>
                    )}
                </div>

                <div className="product-page__breadcrumbs-container">
                  {!loading && (
                    <Breadcrumbs
                      product={product}
                      parentCategories={parentCategories}
                    />
                  )}
                </div>
              </div>

              <div className="col-xs-12 col-sm-7">
                {loading ? (
                  <div className="col-xs-12 col-sm-9">
                    <View padding="xl" className="text-center">
                      <Spinner spinnerName="three-bounce" />
                    </View>
                  </div>
                ) : (
                  <div className="product-page__summary-container">
                    <ProductSummary
                      product={product}
                      loadingDetails={previewingProduct}
                      ratingValue={this.state.ratingValue}
                      ratingCount={this.state.ratingCount}
                      ratings={this.props.ratings}
                    />
                  </div>
                )}
              </div>
            </div>
          </section>

          {!!moreByBrand.length && (
            <section className="hidden-sm product-page__card">
              <div className="row">
                <div className="col-xs-12">
                  <div className="product-page__reco-container">
                    <Text
                      title
                      size="xs"
                      weight="med"
                      tag="h2"
                      className="product-page__heading"
                    >
                      {`More By ${brandName}`}
                    </Text>
                    <Recommendation
                      list={moreByBrand}
                      trackCategory={'More By - ' + brandName}
                    />
                  </div>
                </div>
              </div>
            </section>
          )}

          {!!similarProducts.length && (
            <section className="product-page__card">
              <div className="row">
                <div className="col-xs-12">
                  <div className="product-page__reco-container">
                    <Text
                      title
                      size="xs"
                      weight="med"
                      tag="h2"
                      className="product-page__heading"
                    >
                      You May Also Like
                    </Text>
                    <Recommendation
                      title="You May Also Like"
                      list={similarProducts}
                      trackCategory={'Similar Products - ' + product.title}
                      slidesToShow={5}
                      slidesToScroll={5}
                    />
                  </div>
                </div>
              </div>
            </section>
          )}

          {!!boughtWith.length && (
            <section
              className={`product-page__card ${moreByBrand.length
                ? ''
                : 'hidden-sm'}`}
            >
              <div className="row">
                <div className="col-xs-12">
                  <div className="product-page__reco-container">
                    <Text
                      title
                      size="xs"
                      weight="med"
                      tag="h2"
                      className="product-page__heading"
                    >
                      Often Bought With
                    </Text>
                    <Recommendation
                      list={boughtWith}
                      title="Often Bought With"
                      trackCategory={'Recommendation - ' + category.name}
                      slidesToShow={5}
                      slidesToScroll={5}
                    />
                  </div>
                </div>
              </div>
            </section>
          )}

          {!!product.description_html && (
            <section className="product-page__card">
              <div
                dangerouslySetInnerHTML={{ __html: product.description_html }}
              />
            </section>
          )}

          <section className="product-page__card">
            <ProductRatings
              product={{
                _id: product._id,
                title: product.title,
                url: product.url,
                image: product.image,
                description: product.description,
                sku_id: product.sku_id
              }}
              onRatingsLoaded={ratings => this.handleRatingsLoaded(ratings)}
              ratings={this.props.ratings}
            />
          </section>
        </div>

        <LeadCaptureModal />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    product,
    productLoading,
    previewingProduct,
    moreByBrand,
    moreByBrandLoading,
    similarProducts,
    similarProductsLoading,
    boughtWith,
    boughtWithLoading,
    ratings,
    parentCategories
  } = state.product;
  return {
    product,
    productLoading,
    previewingProduct,
    moreByBrand,
    moreByBrandLoading,
    similarProducts,
    similarProductsLoading,
    boughtWith,
    boughtWithLoading,
    ratings,
    parentCategories,
    address: state.address
  };
}

export default connect(mapStateToProps, { ...productActions })(Product);



// WEBPACK FOOTER //
// ./shared/components/product/index.js